import MasterUploader from "@/components/MasterUploader";
export default function Specializations() {
  return (
    <MasterUploader
      kind="specializations"
      title="Specializations"
      subtitle="Master list of program specializations / streams."
      columns={[
        { key: "specialization_id", label: "Specialization ID", mono: true },
        { key: "specialization_name", label: "Specialization Name" },
      ]}
      templateHint="specialization_id, specialization_name"
    />
  );
}
